import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getTranslate } from '../../localization'
import useStyles from './styles/AccommodationFooter.styles'

interface FooterProps {
  onClick: () => void
  disabled: boolean
  loading: boolean
}

export const Footer: React.FC<FooterProps> = ({
  onClick,
  disabled,
  loading
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.footer}>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        disabled={disabled || loading}
        fullWidth={matches}
        onClick={onClick}>
        {getTranslate('Save Changes')}
        {loading && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
